import sidebarMenu from "../config/sidebar.json";

const initialState = {
    sidebarTabs: sidebarMenu.sidebarTabs || [],
    profileMenuItems: sidebarMenu.profileMenuItems || [],
};

const menuReducer = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state;
    }
};

export default menuReducer;
